"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactDndTestBackend = require("react-dnd-test-backend");
exports.default = _reactDndTestBackend.TestBackend;
//# sourceMappingURL=TestBackend.js.map